(ns teamoesterreich.config
  (:require [cljs.tools.reader :as reader]
            [clojure.string :as str]
            [shadow.cljs.modern :refer (js-await)]
            ["oidc-client-ts" :refer (UserManager)]
            [teamoesterreich.store :as store]
            [teamoesterreich.util.cookies :as cookies]))

(def BUILD_DATE (.-buildDate js/toe_config))

(def CLIENT (.-client js/toe_config))
(def ADMIN_SERVER_URL (.-adminModeUrl js/toe_config))
(def TEST_MACHINE (= "true" (.-testMachine js/toe_config)))
(def BACKEND_SERVER_URL (.-backendUrl js/toe_config))
(def NOMINATIM_URL (.-nominatimUrl js/toe_config))

(def FIREBASE_CONFIG (.-firebaseConfig js/toe_config))
(def GOOGLE_MAPS_API (.-googleMapsApiKey js/toe_config))

(def PUBLIC_BASE_URL (.-baseUrl js/toe_config))

(def TEXT_MAP {})
(def TRANSLATION_MAP {})

(def MAP_CENTER (js/google.maps.LatLng. 49.21025 11.38099))
(def MAP_ZOOM 7.8)

(defn load-texts []
  (js-await [response (js/fetch "/custom/texts.edn")]
    (js-await [body (.text response)]
      (let [t (reader/read-string body)]
        (set! TEXT_MAP t)
        (set! MAP_CENTER (js/google.maps.LatLng. (get-in t [:core :map-center-lat]) (get-in t [:core :map-center-lng])))
        (set! MAP_ZOOM (get-in t [:core :map-zoom])))))

  (js-await [response (js/fetch "/custom/translations.edn")]
    (js-await [body (.text response)]
      (let [t (reader/read-string body)]
        (set! TRANSLATION_MAP t))))
  )

(def user-manager
  (let [um (UserManager. #js{:authority                (.-oidcAuthority js/toe_config)
                             :client_id                (.-oidcClientId js/toe_config)
                             :redirect_uri             (str/join "/" [PUBLIC_BASE_URL "oauth/post-login"])
                             :post_logout_redirect_uri (str/join "/" [PUBLIC_BASE_URL "oauth/post-logout"])
                             :monitorSession           true
                             })
        remove-user (fn [] (.removeUser um))
        fb-logout (fn []
                    (when-let [user (.-currentUser (js/firebase.auth))]
                      (when-not (.-isAnonymous user)
                        (-> (.then (.signOut (.auth js/firebase))
                                   (fn [_]
                                     (cookies/clear!)
                                     (store/reset)
                                     (when (re-matches #"^/lebensretter.*" js/location.pathname)
                                       (.signinRedirect ^js um #js{:redirect_uri (str/join "/" [PUBLIC_BASE_URL "oauth/post-login/lebensretter"])}))
                                     nil))
                            (.catch (fn [e] (js/console.error "logout failed" e)))))))]
    (.addSilentRenewError (.-events um) remove-user)
    (.addAccessTokenExpired (.-events um) remove-user)
    (.addUserUnloaded (.-events um) fb-logout)
    um))